import styled from 'styled-components';
import { Row, Col } from 'antd';
import { StatusRisk } from './constants';
import { Text } from '@/components/Typography';
import { DEFAULT_RISK_RPN_COLOR, ACCEPTABLE_RISK_RPN_COLOR, VERY_HIGH_RISK_RPN_COLOR } from '@/utils/constants';

const BLACK_COLOR = '#262626';
const DEFAULT_COLOR = '#FFF';
const ACCEPTABLE_COLOR = ACCEPTABLE_RISK_RPN_COLOR;
const HIGH_RISK_COLOR = VERY_HIGH_RISK_RPN_COLOR;

const StatusRiskColor = {
	[StatusRisk.DEFAULT]: DEFAULT_COLOR,
	[StatusRisk.ACCEPTABLE]: ACCEPTABLE_COLOR,
	[StatusRisk.HIGH_RISK]: HIGH_RISK_COLOR
};

const FontRiskColor = {
	[StatusRisk.DEFAULT]: BLACK_COLOR,
	[StatusRisk.ACCEPTABLE]: DEFAULT_COLOR,
	[StatusRisk.HIGH_RISK]: DEFAULT_COLOR
};

interface HeaderProps {
	$backgroundColor: string;
}

interface TextProps {
	$color: string;
}

interface ContentProps {
	$status?: number;
	$isResult?: boolean;
}

export const Container = styled(Row)`
	height: 90%;
	overflow: hidden;
	text-align: center;
	border-radius: 12px;
	border: 3px solid ${DEFAULT_RISK_RPN_COLOR};
`;

export const Header = styled(Col)<HeaderProps>`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 50%;
	padding: 40px 0;
	background-color: ${({ $backgroundColor }) => $backgroundColor};
	@media (min-width: 1600px) {
		padding: 20px 0;
	}
`;

export const Label = styled(Text)<TextProps>`
	font-size: 18px;
	font-weight: 600;
	color: ${({ $color }) => $color};
`;

export const Description = styled(Text)<TextProps>`
	font-size: 16px;
	color: ${({ $color }) => $color};
`;

export const ContentContainer = styled(Col)<ContentProps>`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 50%;
	font-size: 25px;
	font-weight: 600;
	background-color: ${({ $status, $isResult }) =>
		$isResult ? StatusRiskColor[$status as StatusRisk] : DEFAULT_COLOR};
	span {
		color: ${({ $status, $isResult }) => ($isResult ? FontRiskColor[$status as StatusRisk] : BLACK_COLOR)};
	}
`;
